import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box, Avatar } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LinkIcon from '@mui/icons-material/Link';
import PersonIcon from '@mui/icons-material/Person';

export default function CardIntegrantes({ name, subtitle, descricao, imagem, email, link }) {
  const normalizedEmail = email
    ? (email.startsWith('mailto:') ? email : `mailto:${email}`)
    : '';
  const hasLink = Boolean(link);

  return (
    <Card 
      sx={{ 
        maxWidth: 345, 
        borderRadius: 3, 
        boxShadow: 3, 
        textAlign: 'center', 
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      <CardMedia
        component="img"
        height="240"
        image={imagem}
        alt={name}
        sx={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
        onError={(e) => {
          e.target.src = ''; // Remove a imagem quebrada
        }}
      />
      {!imagem && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 240, bgcolor: '#e0e0e0' }}>
          <Avatar sx={{ width: 120, height: 120, bgcolor: '#757575' }}>
            <PersonIcon sx={{ fontSize: 60 }} />
          </Avatar>
        </Box>
      )}
      <CardContent>
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ fontSize: '1.5rem', color: '#333' }}>
          {name}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" sx={{ fontSize: '1.1rem', color: '#555' }}>
          {subtitle}
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph sx={{ fontSize: '1rem', marginTop: 2, color: '#666' }}>
          {descricao}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            gap: 1.5,
            mt: 3,
          }}
        >
          {normalizedEmail && (
            <Button
              variant="contained"
              color="primary"
              startIcon={<EmailIcon />}
              href={normalizedEmail}
              sx={{
                flex: 1,
                minWidth: 0,
                textTransform: 'none',
                whiteSpace: 'nowrap',
                padding: '10px 16px',
                fontWeight: 'bold',
                borderRadius: 2,
                transition: 'background-color 0.3s ease',
                '&:hover': {
                  backgroundColor: '#1565c0',
                }
              }}
            >
              E-mail
            </Button>
          )}
          {hasLink && (
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<LinkIcon />}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                flex: 1,
                minWidth: 0,
                textTransform: 'none',
                whiteSpace: 'nowrap',
                padding: '10px 16px',
                fontWeight: 'bold',
                borderRadius: 2,
                borderColor: '#b0bec5',
                transition: 'border-color 0.3s ease, color 0.3s ease',
                '&:hover': {
                  borderColor: '#009688',
                  color: '#009688',
                }
              }}
            >
              Saiba mais
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
